<template>
    <div>
        <ul class="nav justify-content-center">
            <li class="nav-item">
                <a class="nav-link" href="https://github.com/PedroHdev"><img width="32" src="../assets/github.svg"></a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'Navbar'
}
</script>

<style>

</style>